import { concat, hash } from '@ember/helper';

import { t } from 'ember-intl';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import { Nodes } from './nodes';
import styles from './styles.module.css';

const tScope = 'record_detail.forms.a11y_report.';
const bem = getBem(styles);

const getLevel = (assertion) => {
  const criterias = assertion.meta?.criteria ?? [];
  const level = new Set();

  for (const criteria of criterias) {
    level.add(criteria.level);
  }

  return [...level].join(' / ');
};

export const Assertions = <template>
  <div class={{bem 'header'}}>
    <div class={{bem 'status'}}></div>
    <div class={{bem 'name'}}></div>
    <div class={{bem 'level'}}>
      {{t (concat tScope 'level')}}
    </div>
    <div class={{bem 'result'}}>
      {{t (concat tScope 'passed')}}
    </div>
    <div class={{bem 'result'}}>
      {{t (concat tScope 'warning')}}
    </div>
    <div class={{bem 'result'}}>
      {{t (concat tScope 'failed')}}
    </div>
  </div>
  {{#each @assertions as |assertion|}}
    {{#unless assertion.meta.inapplicable}}
      {{! template-lint-disable no-nested-interactive }}
      <details class={{bem 'details'}}>
        <summary class={{bem 'summary'}}>
          <div class={{bem 'status' (hash is=assertion.meta.outcome)}}>
            {{svgJar 'chevron-up' class=(bem 'arrow')}}
          </div>
          <h3 class={{bem 'name'}}>{{assertion.name}}</h3>
          <div class={{bem 'level'}}>
            {{getLevel assertion}}
          </div>
          <div class={{bem 'result'}}>
            {{assertion.meta.passed}}
          </div>
          <div class={{bem 'result'}}>
            {{assertion.meta.warning}}
          </div>
          <div class={{bem 'result'}}>
            {{assertion.meta.failed}}
          </div>
        </summary>

        <div class={{bem 'detail'}}>
          <h4 class={{bem 'detail-headline'}}>
            {{t (concat tScope 'description')}}
          </h4>
          {{assertion.description}}<br />
          <a
            href={{assertion.meta.url}}
            target='_blank'
            rel='noopener noreferrer'
          >
            {{assertion.meta.url}}
          </a>
          <h4 class={{bem 'detail-headline'}}>
            {{t (concat tScope 'criteria')}}
          </h4>
          {{#each assertion.meta.criteria as |criteria|}}
            <a href={{criteria.url}} target='_blank' rel='noopener noreferrer'>
              {{criteria.name}}
              {{criteria.principle}}
              ({{t (concat tScope 'level')}}
              {{criteria.level}})
            </a><br />
          {{/each}}
          <h4 class={{bem 'detail-headline'}}>
            {{t (concat tScope 'results')}}
          </h4>
          <Nodes @nodes={{assertion.nodes}} />
        </div>
      </details>
      {{! template-lint-enable no-nested-interactive }}
    {{/unless}}
  {{/each}}
</template>;
